var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partner-slide",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-offset": "300",
      "data-aos-delay": "200",
      "data-aos-duration": "600"
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/1.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/2.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/3.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/4.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/5.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/6.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/7.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/8.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/9.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/10.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/1.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/2.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/3.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/4.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/5.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/6.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/7.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/8.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/9.png",
      "alt": ""
    }
  })])])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "partner-slide__box",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('div', {
    staticClass: "partner-slide__thumb"
  }, [_c('img', {
    attrs: {
      "src": "/images/main/partners/10.png",
      "alt": ""
    }
  })])])], 1)]), _vm._m(0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "prev",
    attrs: {
      "type": "button"
    }
  }), _c('button', {
    staticClass: "next",
    attrs: {
      "type": "button"
    }
  })]);
}]

export { render, staticRenderFns }